import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@sr/ui-library';
import { Control, useWatch } from 'react-hook-form';
import { getAddressFieldLabels } from '../../shared/addressLabels';
import { countryAwareRequiredString } from '../../shared/countryAwareStringSchema';
import { WORKSPACE_DETAILS_FORM_FIELDS } from '../../shared/fieldNames';
import { WorkspaceDetailsFormValues } from '../../shared/types';

interface AddressStateFieldProps {
  control: Control<WorkspaceDetailsFormValues>;
}

/** State/Province/Region — label follows the selected address country. */
export const AddressStateField = ({ control }: AddressStateFieldProps) => {
  const country = useWatch({
    control,
    name: WORKSPACE_DETAILS_FORM_FIELDS.addressCountry,
  });
  const label = getAddressFieldLabels(country).state;

  return (
    <FormField
      name={WORKSPACE_DETAILS_FORM_FIELDS.addressState}
      control={control}
      render={({ field }) => (
        <FormItem>
          <FormLabel asterisk>{label}</FormLabel>
          <FormControl>
            <Input {...field} placeholder={`Enter ${label.toLowerCase()}`} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

AddressStateField.schema = countryAwareRequiredString(
  'state',
  WORKSPACE_DETAILS_FORM_FIELDS.addressState,
);
